import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";

const TransactionDetailsModal = ({ transaction, open, onClose }) => {
  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <DialogTitle>Transaction Details</DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <Divider style={{ marginBottom: "10px" }} />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <CustomTypography
                color="var(--text-heading)"
                fontSize="14px"
                fontWeight={400}
              >
                Client
              </CustomTypography>
              <TextField
                type="text"
                size="small"
                margin="dense"
                placeholder="Client Name"
                value={transaction?.client_id?.name || ""}
                fullWidth
                InputProps={{
                  readOnly: true,
                  style: {
                    color: "var(--text-primary)",
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Order Id
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={transaction?.order_id || ""}
                InputProps={{
                  readOnly: true,
                  style: {
                    color: "var(--text-primary)",
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Order Number
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={transaction?.order_number || ""}
                InputProps={{
                  readOnly: true,
                  style: {
                    color: "var(--text-primary)",
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Shipment Cost
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={transaction?.shipment_cost || ""}
                InputProps={{
                  readOnly: true,
                  style: {
                    color: "var(--text-primary)",
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            {transaction?.message ? (
              <Grid item xs={12} md={12}>
                <CustomTypography
                  color={"var(--text-heading)"}
                  fontSize={14}
                  fontWeight={400}
                >
                  Message
                </CustomTypography>
                <Typography
                  size="small"
                  autoFocus
                  margin="dense"
                  variant="outlined"
                  type="text"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                    style: {
                      color: "var(--text-primary)",
                      backgroundColor: "var(--bg-input)",
                    },
                  }}
                >
                  {transaction.message}
                </Typography>
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: 10 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TransactionDetailsModal;
